/**
 * Decodifica in sicurezza un parametro URL e verifica che appartenga al dominio consentito.
 *
 * @param value Stringa codificata da decodificare, tipicamente ottenuta da `URLSearchParams`.
 * @returns L'URL decodificato se valido e appartenente a ceralia.it o al dominio Supabase autorizzato, altrimenti `null`.
 */
export function safeDecodeUrlParam(value: string | null): string | null {
  if (!value) return null;
  try {
    const decoded = decodeURIComponent(value);
    const url = new URL(decoded);
    if (
      url.hostname === 'www.ceralia.it' ||
      url.hostname.endsWith('.ceralia.it') ||
      url.hostname === 'gxnmcjgxredhctobhkki.supabase.co'
    ) {
      return decoded;
    }
    return null;
  } catch {
    return null;
  }
}
